/**
 * LoginModal
 * 组件放在全局Layout 处，在页面任何一个地方可调用唤起
 * 包含登录、注册、忘记密码操作
 */
import React, { useEffect, useMemo } from 'react'
import { observer, useLocalObservable } from 'mobx-react-lite'
import { LOGIN_TAB_TYPE } from '@/constants'
import { useModalWrap } from '@/components'
import Login from '@/components/LoginModal/components/Login'
import Register from '@/components/LoginModal/components/Register'
import Forgot from '@/components/LoginModal/components/Forgot'
import styles from './index.module.less'
import globalStore from '@/globalStore'
import { getStorage } from '@/utils/storage'

const LoginModal = () => {
  const globalMobx = useLocalObservable(() => globalStore)

  const ModalChildren = useMemo(() => {
    let component = null
    switch (globalMobx.currentAction) {
      case 'login':
        component = Login
        break
      case 'register':
        component = Register
        break
      case 'forgot':
        component = Forgot
        break
      default:
        component = Login
        break
    }
    return component
  }, [globalMobx.currentAction])

  const {
    showModal: showLoginModal,
    hideModal: hideLoginModal,
    render: renderLoginModal,
  } = useModalWrap({
    modalProps: {
      title: null,
      width: 956,
      bodyStyle: { padding: 0 },
      footer: null,
      maskClosable: false,
      className: styles['login-modal'],
      afterClose: () => {
        globalMobx.currentAction = 'login'
        globalMobx.lastLoginTab = LOGIN_TAB_TYPE.CODE
      },
      // closable:false,
      onCancel: () => {
        globalMobx.loginModalToggle(false)
      },
    },
    children: () => (
      <div>
        <ModalChildren />
      </div>
    ),
  })

  useEffect(() => {
    const localLastLoginTab = getStorage('lastLoginTab')
    if (globalMobx.loginModalVisible) {
      localLastLoginTab && globalMobx.updateGlobalStore('lastLoginTab', localLastLoginTab)
      showLoginModal()
    } else {
      hideLoginModal()
    }
  }, [globalMobx.loginModalVisible])
  return <div className={styles['my-work-page']}>{renderLoginModal()}</div>
}

export default observer(LoginModal)
